import React from 'react';

import { ContainerDiv, ContainerLink } from './loyalty-basic-card-widget.styled';

const LoyaltyBasicCardContainer: React.FC<{ link?: string | null; children: React.ReactNode }> = ({
  link,
  children,
}) => {
  return (
    <>
      {link ? (
        <ContainerLink data-testid="loyalty-basic-card-container" to={link}>
          {children}
        </ContainerLink>
      ) : (
        <ContainerDiv data-testid="loyalty-basic-card-container">{children}</ContainerDiv>
      )}
    </>
  );
};

export default LoyaltyBasicCardContainer;
